module.exports = __webpack_public_path__ + "img/3.2959ea6d.jpg";